export const INTERNAL_CASE_STATUSES = [
    "unassigned",
    "assigned",
    "in_progress",
    "on_hold",
    "closed",
];
export const INTERNAL_CASE_STATUS_LABELS_FA = {
    unassigned: "ارجاع‌نشده",
    assigned: "ارجاع‌شده",
    in_progress: "در حال پیگیری",
    on_hold: "متوقف‌شده",
    closed: "مختومه",
};
